import { Collapse } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import clsx from "clsx";
import he from "he";
import style from "./style.module.scss";

const MobileMenuItem = ({ category, expand, setMenuOpenId }) => (
  <div className={style.mobileMenuItem}>
    {category.children ? (
      <>
        <div className={style.parentMenu}>
          <a href={category.url}>{he.decode(category.name)}</a>

          <ExpandMoreIcon
            onClick={() =>
              setMenuOpenId((prevId) =>
                prevId !== category.cat_ID ? category.cat_ID : 0
              )
            }
            className={clsx(style.expandMoreIcon, expand && style.open)}
          />
        </div>

        <Collapse className={style.subMenu} in={expand}>
          {Object.values(category.children).map((category) => (
            <a key={category.cat_ID} href={category.url}>
              {he.decode(category.name)}
            </a>
          ))}
        </Collapse>
      </>
    ) : (
      <a href={category.url}>{category.name}</a>
    )}
  </div>
);

export default MobileMenuItem;
